import { useMemo } from "react";
import { useLanguageContext } from "../../../../context/LanguageContext";
import TerminalVisitorTypesView from "./TerminalVisitorTypesView";

function TerminalVisitorTypes({ terminalData, setTerminalData, visitorTypes }) {
  const { translateEntity } = useLanguageContext();

  const visitorTypeLabels = useMemo(() => {
    return visitorTypes.reduce((labels, visitorType) => {
      labels[visitorType.id] = translateEntity(visitorType, "label");
      return labels;
    }, {});
  }, [visitorTypes, translateEntity]);

  const availableVisitorTypes = useMemo(() => {
    return visitorTypes.filter((visitorType) => {
      return !terminalData.visitor_types.some(
        (terminalVisitorType) =>
          terminalVisitorType.visitor_type_id === visitorType.id,
      );
    });
  }, [visitorTypes, terminalData]);

  /**
   * This method will add a visitor type to the terminal data
   * @param {int} visitorTypeId
   */
  function onVisitorTypeAdd(visitorTypeId) {
    setTerminalData((prev) => ({
      ...prev,
      visitor_types: [
        ...prev.visitor_types,
        {
          visitor_type_id: visitorTypeId,
          show_button: true,
        },
      ],
    }));
  }

  /**
   * This method will update a visitor type's property in the terminal data
   * @param {int} visitorTypeId
   * @param {string} key
   * @param {*} value
   */
  function onVisitorTypeChange(visitorTypeId, key, value) {
    setTerminalData((prev) => ({
      ...prev,
      visitor_types: prev.visitor_types.map((visitorType) =>
        visitorType.visitor_type_id === visitorTypeId
          ? { ...visitorType, [key]: value }
          : visitorType,
      ),
    }));
  }

  /**
   * This method will delete a visitor type from the terminal data
   * @param {int} visitorTypeId
   */
  function onVisitorTypeDelete(visitorTypeId) {
    setTerminalData((prev) => ({
      ...prev,
      visitor_types: prev.visitor_types.filter(
        (visitorType) => visitorType.visitor_type_id !== visitorTypeId,
      ),
    }));
  }

  return (
    <TerminalVisitorTypesView
      availableVisitorTypes={availableVisitorTypes}
      visitorTypeLabels={visitorTypeLabels}
      terminalData={terminalData}
      onVisitorTypeAdd={onVisitorTypeAdd}
      onVisitorTypeChange={onVisitorTypeChange}
      onVisitorTypeDelete={onVisitorTypeDelete}
    />
  );
}

export default TerminalVisitorTypes;
